import dayjs from "dayjs";

import type { ExtensionGovernanceUser } from "app/pages/sales-intelligence/modules/extension-management/types";

import type { StatusFilterValue } from "./constants";
import { STATUS_FILTER_ALL } from "./constants";

export const matchesSearch = (user: ExtensionGovernanceUser, term: string): boolean => {
    const lowerTerm = term.toLowerCase();

    return (
        user.userName.toLowerCase().includes(lowerTerm) ||
        user.userEmail.toLowerCase().includes(lowerTerm) ||
        (user.jobTitle?.toLowerCase().includes(lowerTerm) ?? false)
    );
};

export const filterUsers = (
    users: ExtensionGovernanceUser[],
    statusFilter: StatusFilterValue,
    searchTerm: string,
): ExtensionGovernanceUser[] => {
    let result = users;

    if (statusFilter !== STATUS_FILTER_ALL) {
        result = result.filter((user) => user.status === statusFilter);
    }

    if (searchTerm) {
        result = result.filter((user) => matchesSearch(user, searchTerm));
    }

    return result;
};

export const computeStatusCounts = (users: ExtensionGovernanceUser[]): Record<StatusFilterValue, number> => {
    const counts: Record<StatusFilterValue, number> = {
        [STATUS_FILTER_ALL]: users.length,
        Active: 0,
        Inactive: 0,
        NotInstalled: 0,
    };

    for (const user of users) {
        counts[user.status]++;
    }

    return counts;
};

export const formatDate = (dateString: string): string => {
    const date = dayjs(dateString);

    if (!date.isValid()) {
        return dateString;
    }

    return date.format("DD/MM/YYYY");
};
